import { RootDomain } from 'model/root.model';
import { request } from 'libs/request';

type Log = { name: string; message: { [key: string]: any }, timestamp: number, session: string }
type EventLogPayload = Omit<Log, 'timestamp' | 'session'>;
type CreateLogPayload = { body: Log, applicationKey: string, baseUrl: string };

export const log = RootDomain.event<EventLogPayload>();
export const createLogFx = RootDomain.effect<CreateLogPayload, void>({
	handler: (params) => {
		request({
			method: 'POST',
			baseUrl: params.baseUrl,
			url: `/sessions/${params.body.session}/log`,
			headers: {
				'hive-application-key': params.applicationKey,
			},
			body: params.body,
		});
	},
});

// sample({
// 	source: {
// 		applicationKey:
// 		applicationKey$,
// 		baseUrls: baseUrls$,
// 		sessionConfig: sessionConfig$,
// 	},
// 	clock: log,
// 	fn: (source, payload): CreateLogPayload => ({
// 		body: {
// 			...payload,
// 			timestamp: parseInt((Date.now() / 1000) + ''),
// 			session: source.sessionConfig.id,
// 		},
// 		applicationKey: source.applicationKey,
// 		baseUrl: source.baseUrls.apiBaseUrl,
// 	}),
// 	target: createLogFx,
// });
